import React from 'react'
import WithStoreSettings from '../../shared/WithStoreSettings'
import MockupGeneratorListProduct from './MockupGeneratorListProduct'

const Step1Container = (props) => {
    return (
        <div className="Step1Container">
            <div className="MockupGeneratorContainer">
                <MockupGeneratorListProduct {...props} />
            </div>
        </div>
    )
}
// eslint-disable-next-line import/no-anonymous-default-export
export default function (props) {
    return (
        <WithStoreSettings>
            {(store) => {
                return <Step1Container {...props} store={store} />
            }}
        </WithStoreSettings>
    )
}

